export const emailRegexConstant = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
export const phoneRegexConstant = /^[0-9]{10}$/;
export const passwordRegexConstant =
  /^(?=.*[A-Za-z])(?=.*\d)(?=.*[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]).+$/;
export const priceRegex = /^(?!0\d)\d{1,10}(\.\d{1,2})?$/;
